export const CONFIRM_AGENT_KEY_COLLECTION =
  'entry-access/management/keys-with-agent/agent/key/confirm';
